export const featuredData = [
  {
    url: "https://youtu.be/Zv37wNzxfEw",
    gitUrl: "https://github.com/Akshat-iitk/CareerCraft",
    liveUrl: "https://carrercraft.netlify.app/",
    mainHeader: "CareerCraft",
    mainContent: `A Responsive React Job Portal web application made using React and styled using Headless UI and tailwind.`,
    probDescription: `React | React Router | Tailwind | GIT | HeadlessUI | Moment | CSS | js | HTML | Netlify`,
    featDescription: `Build using React and styled through headless UI and tailwind | Navigate through various pages using React routing | Added react-toolkit for usestate variable | Seperate login/Signup for User and Company | CareerCraft has an outstanding, responsive header for mobile users | Crafted with different components.Every section is designed with your ease of use in mind 
 Deployed live using Netlify`,
  },
  {
    url: "https://youtu.be/UIiN1YicP3U",
    gitUrl: "https://github.com/Akshat-iitk/Caption-Craze",
    
    mainHeader: "CaptionCraze",
    mainContent: `A backend (Node, Express) extensive website where user can effortlessly create a post with a caption and description, with user authentication`,
    probDescription: `Node | Express | MongoDB | Mongoose | Passport.js | EJS | JS | Tailwind | Bootstrap | Multer  `,
    featDescription: `Created with Node, Express, and EJS | Responsive Login and SignUP page | User authentication using Passport authentication middleware from nodejs | For posting images, Multer is employed, | Additionally, users can easily update their profile images. | Other transition effects using core JS `,
  },

  {
    url: "https://youtu.be/xSpL5-IGgac",

    gitUrl: "https://github.com/Akshat-iitk/Portfolio",
    mainHeader: "Personal Portfolio",
    liveUrl: "https://portfolio-akshat.netlify.app/",
    mainContent:
      "My personal portfolio website to showcase my projects and skillset. Created using HTML, CSS, ReactJS, Chakra UI, etc. All my contact details are provided on this website, feel free to reach out.",
      probDescription: `React | Tailwind | Chakra UI | React Libraries | etc. `,
    featDescription: `Responsive across devices | Dark theme using Chakra UI | Smooth Scrolling among components | Button to navigate to home of the page`,
  },
  {
    url: "https://youtu.be/5drtQWkh_qs",

    gitUrl: "https://github.com/Akshat-iitk/CurrencyChange",
    mainHeader: "Currency Convertor",
    liveUrl: "https://currencychange-by-at.netlify.app/",
    probDescription : "HTML | CSS | JS | Tailwind | FetchAPI | Fonticons etc" ,
    mainContent:
      "A resposive currency convertor using core HTML | CSS | JS | Tailwind  ",
    featDescription: `Responsive across devices | Change currency with flag | Exchange button to exchange currency with flag `,
  },
  
];
